import type { ExtractAtomValue } from 'jotai';
import { atom } from 'jotai';
import type { MediaItemT } from '../../labelling/types/studio-interface.type';
export const multiVideoListAtom = atom<MediaItemT[]>([]);
export const selectedVideoIndexAtom = atom<number>(0);
export const selectedVideoAtom = atom(get => {
  const multiVideoList = get(multiVideoListAtom);
  return multiVideoList[get(selectedVideoIndexAtom)];
});
export type MultiVideoAtomHydrationList = [typeof multiVideoListAtom, ExtractAtomValue<typeof multiVideoListAtom>];